/**
 * 64-bit FNV-1a — not cryptographic, doesn't need to be. The only property
 * every caller relies on is "not the raw GUID and not casually reversible to
 * it," not resistance to a determined attacker who already has a specific
 * player's GUID to test against a specific table or tournament. Synchronous
 * and dependency-free rather than an async Web Crypto `subtle.digest`: the
 * two callers (leaderboardRowId.ts, handHistoryPlayerId.ts) both need to run
 * from a plain `useMemo`, not async state, and without depending on
 * SubtleCrypto being present in every test/runtime environment.
 *
 * Mirrors serverless-v2/shared/lib/fnv1a.js — this file exists separately
 * rather than importing that one because this is a Create-React-App bundle
 * with no build-time access to the Lambda-only serverless-v2/shared package.
 * Any change here MUST be mirrored there too, byte-for-byte, or the client
 * can no longer recompute a digest the server already published.
 */

// BigInt() calls rather than `123n` literals: this project's tsconfig targets
// ES5, and BigInt literal syntax requires TS's target to be ES2020+ even
// though the runtime (every supported browser, and Node) already supports
// BigInt itself.
const FNV_OFFSET_BASIS = BigInt('0xcbf29ce484222325');
const FNV_PRIME = BigInt('0x100000001b3');
const MASK_64 = BigInt('0xffffffffffffffff');

export function fnv1a64Hex(input: string): string {
  let hash = FNV_OFFSET_BASIS;
  for (let i = 0; i < input.length; i++) {
    hash ^= BigInt(input.charCodeAt(i));
    hash = (hash * FNV_PRIME) & MASK_64;
  }
  return hash.toString(16).padStart(16, '0');
}
